import { ref } from "vue";
import { useStore } from "vuex";
import axios from "axios";
import Swal from "sweetalert2";
import { linkThaid } from "@/utils/thaid-link";
import getThaidToken from "@/utils/get-thaid-token.js";
import store from "@/store";

const swalCustom = Swal.mixin({
  customClass: {
    confirmButton: "btn btn-primary m-1",
    cancelButton: "btn btn-outline-secondary m-1",
  },
  buttonsStyling: false,
});

export function useBoraData() {
  const vuexStore = useStore();
  const _LK2token = ref("");
  const pvdUserId = ref("");

  const getPersonInfoFromBora = async (targetPIDParam) => {
    const targetPIDFromPage = (targetPIDParam ?? "")
      .toString()
      .trim()
      .replace(/[^\d]/g, "");
    const targetPID = targetPIDFromPage || null;

    if (!targetPID || targetPID.length !== 13) {
      await swalCustom.fire({
        icon: "warning",
        title: "ไม่พบเลขบัตรประชาชน",
        text: "กรุณากรอกเลขบัตรประชาชนเป้าหมายให้ครบ 13 หลัก",
        confirmButtonText: "ปิด",
      });
      return null;
    }

    const thaidTokens = await getThaidToken();
    if (!thaidTokens?.access_token || !thaidTokens?.id_token) {
      const result = await swalCustom.fire({
        icon: "warning",
        title: "กรุณาเข้าสู่ระบบด้วย ThaID ก่อน",
        html:
          "ตรวจไม่พบข้อมูลการยืนยันตัวตน<br>กรุณาเข้าสู่ระบบผ่าน <b>ThaID</b> ก่อนใช้งาน",
        showCancelButton: true,
        confirmButtonText: "ไปหน้า Login ThaID",
        cancelButtonText: "ปิด",
      });
      if (result.isConfirmed) {
        linkThaid();
      }
      return null;
    }

    const apiBase = process.env.VUE_APP_BASE_API || "";

    try {
      const requestBody = {
        access_token: thaidTokens.access_token,
        id_token: thaidTokens.id_token,
        targetPID,
        is_dev: false
      };

      const response = await axios.post(
        `${apiBase}dc/personalInfo`,
        requestBody,
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      const data = JSON.parse(response.data.data);
      console.log('data')
console.log(data)
      // if (data && response.success === false) {
        if (data && response.status === false) {
        const err = data.error || {};
        await swalCustom.fire({
          icon: "error",
          title: err.code || "เกิดข้อผิดพลาด",
          text: err.message || "ไม่สามารถดึงข้อมูลได้",
          footer: err.detail ? `<small>${err.detail}</small>` : undefined,
          confirmButtonText: "ปิด",
        });
        return null;
      }

      if (data && data.access_token) {
        _LK2token.value = data.access_token || "";
      }
      pvdUserId.value = targetPID;
      return data;
    } catch (error) {
      console.error("dc/personalInfo API Error:", error);
      const status = error.response?.status;
      const errData = error.response?.data;

      let errCode;
      let errMessage;

      if (status === 401) {
        // ปัญหาเรื่องสิทธิ์การเข้าถึงข้อมูล
        errCode = "401";
        errMessage = "ไม่สามารถเข้าถึงข้อมูลได้";
      } else if (status === 404) {
        // ไม่พบข้อมูลจากทะเบียนราษฎร์
        errCode = "404";
        errMessage = "ไม่พบข้อมูลจากทะเบียนราษฎร์";
      } else {
        errMessage =
          errData?.error?.message ||
          errData?.message ||
          error.message ||
          "ไม่สามารถดึงข้อมูลจากทะเบียนราษฎร์ได้";
        errCode =
          errData?.error?.code ||
          `HTTP ${status || "Network Error"}`;
      }

      await swalCustom.fire({
        icon: "error",
        title: errCode,
        text: errMessage,
        confirmButtonText: "ปิด",
      });
      return null;
    }
  };

  // ข้อมูลที่อยู่/บ้านจาก BORA
  const boraHouseholdInfo = async (targetPIDParam) => {
    return {
      HouseManner: "",
      HousingName: "",
      CommunityName: "",
      ZipCode: "12345",
    }
  }
  //   const pid =
  //     (targetPIDParam || pvdUserId.value || "").toString().trim() || "";

  //   if (!pid) {
  //     Swal.fire(
  //       "เกิดข้อผิดพลาด",
  //       "ไม่พบเลขบัตรประชาชนสำหรับเรียกข้อมูลที่อยู่จากทะเบียนราษฎร์",
  //       "error"
  //     );
  //     return null;
  //   }

  //   // ถ้ายังไม่มี token หรือตัวเลข pid เปลี่ยน ให้ login ใหม่ก่อน
  //   if (!_LK2token.value || pvdUserId.value !== pid) {
  //     const loginData = await getPersonInfoFromBora(pid);
  //     if (!loginData) {
  //       return null;
  //     }
  //   }

  //   try {
  //     const response = await axios.get(
  //       "https://iservices.m-society.go.th:443/ictcmsodopalinkage2/ICTCMSODOPInterChange.RequestHouseInformation.svc/ICTCMSORequestHouseInformationService",
  //       {
  //         headers: { Authorization: `Bearer ${_LK2token.value}` },
  //         params: { id: pid },
  //       }
  //     );
  //     return response.data;
  //   } catch (error) {
  //     console.error("Bora API Error (household):", error);
  //     Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถดึงข้อมูลจาก BORA ได้", "error");
  //     return null;
  //   }
  // };

  return {
    _LK2token,
    pvdUserId,
    boraHouseholdInfo,
    getPersonInfoFromBora,
  };
}

  //await getPersonInfoFromBora();
  // const boraHhInfo = {
  //     HouseManner: "",
  //     HousingName: "",
  //     CommunityName: "",
  //     ZipCode: "12345",
  //   };

//await getPersonInfoFromBora();
//     let bora_data = {
//   "Code": "0",
//   "Message": "",
//   "pid": "1100100123456",
//   "title": "นาย",
//   "firstname": "เดชาพล",
//   "lastname": "ใจดีมาก",
//   "gender": "หญิง",
//   "dateofbirth": "25380101",
//   "nationality": "ไทย",
//   "homestatus": "ผู้อยู่อาศัย",
//   "personstatus": "ปกติ",
//   "moveindate": "25600520",
//   "age": "31",
//   "fatherpid": "3100100987654",
//   "motherpid": "5100100456789",
//   "fathername": "สมชาย ใจดีมาก",
//   "mothername": "สมศรี ใจดีมาก",
//   "fathernationality": "ไทย",
//   "mothernationality": "ไทย",
//   "changenationality": "-",
//   "changenationalitydate": "",
//   "houseid": "12-1",
//   "housenumber": "99/1",
//   "moo": "5",
//   "alley": "-",
//   "soi": "สุขุมวิท 101",
//   "road": "สุขุมวิท",
//   "subdistrict": "บางนาเหนือ",
//   "district": "บางนา",
//   "province": "กรุงเทพมหานคร",
//   "Reserve": "",
//   "EnglishTitle": "Miss",
//   "EnglishFirstName": "SOMYING",
//   "EnglishMiddleName": "",
//   "EnglishLastName": "JAIDEEMAK"
// };